import { ToolboxComponent } from '../toolbox/ToolboxComponent'

/**
 * A context menu toolbox
 * @memberof Toolbox
 * @ignore
 */
class ContextMenuComponent extends ToolboxComponent {
    getActiveToolGroupNames() {
        return [
            'context-menu-primary',
            'context-menu-document',
            'context-menu-spelling'
        ]
    }

    render($$) {
        const el = $$('div')
            .addClass('dw-toolbox-wrapper')
            .addClass('dw-toolbox-menu')

        if (!this.state.hints) {
            return el
        }

        if (this.state.active !== true) {
            el.addClass('dw-hidden')
        }

        const activeToolGroups = this.state.activeToolGroups

        activeToolGroups.forEach((toolGroup) => {
            const toolGroupProps = Object.assign({}, toolGroup, {
                toolStyle: this.getToolStyle(),
                showLabels: true,
                showIcons: toolGroup.name === 'context-menu-primary',
                showHints: false
            })

            if (toolGroupProps.tools.size > 0) {
                const toolGroupEl = $$(toolGroup.Class, toolGroupProps)
                el.append(toolGroupEl)
            }
        })

        return el
    }

    didUpdate() {
        if (!this.state.hints) {
            return
        }

        let mouseBounds = this.state.hints.mouseBounds
        let contentWidth = this.el.htmlProp('offsetWidth')

        // By default, context menu are aligned left bottom to the mouse coordinate clicked
        this.el.css('top', mouseBounds.top + 12)
        let leftPos = mouseBounds.left - 12

        // Must not exceed left bound
        leftPos = Math.max(leftPos, 0)

        // Must not exceed right bound
        let maxLeftPos = mouseBounds.left + mouseBounds.right - contentWidth
        leftPos = Math.min(leftPos, maxLeftPos)
        this.el.css('left', leftPos)
    }
}

export {ContextMenuComponent}
